export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-100 via-background-100 to-primary-50/30 rounded-2xl p-6 md:p-10 border border-background-200/60 overflow-hidden relative">
          <div className="flex flex-col lg:flex-row items-center gap-8 relative z-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                移动观影 · 随时随地
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg">
                午马影院全面适配移动端浏览，在手机和平板上同样享受高清流畅的观影体验。无需下载APP，浏览器打开即可观看，支持手势控制音量、亮度与进度，躺在床上也能畅享影院级视听效果。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-5">
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <span className="w-6 h-6 flex items-center justify-center text-primary-500">
                    <i className="ri-checkbox-circle-line"></i>
                  </span>
                  自适应屏幕
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <span className="w-6 h-6 flex items-center justify-center text-primary-500">
                    <i className="ri-checkbox-circle-line"></i>
                  </span>
                  手势控制播放
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <span className="w-6 h-6 flex items-center justify-center text-primary-500">
                    <i className="ri-checkbox-circle-line"></i>
                  </span>
                  流量优化模式
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20a%20movie%20streaming%20app%20interface%20with%20movie%20posters%20grid%2C%20clean%20modern%20UI%20design%2C%20warm%20dark%20theme%2C%20cinematic%20aesthetic%2C%20minimal%20layout%2C%20soft%20lighting&width=360&height=640&seq=app-mobile-01&orientation=portrait"
                  alt="午马影院移动端界面"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}